import _ from 'lodash';

const SafeVersionService = function() {
  const findSafeVersion = (safeVersions, fixVersion) => {
    // Get all the safeVersions list checking done early
    if (!safeVersions || safeVersions.length < 1) {
      return '';
    }

    // If there are safe versions and a fix version
    if (fixVersion) {
      if (_.findIndex(safeVersions, { version: fixVersion }) >= 0) {
        return fixVersion;
      }
    }

    // Find the first released version
    const releasedVersionIndex = _.findLastIndex(safeVersions, { releaseStatus: 'Release' });
    // If there is a released version
    if (releasedVersionIndex >= 0) {
      return safeVersions[releasedVersionIndex].version;
    } else {
      // If there is no released version then pick the version directly after the verison range.
      // This will be the last item in the list of versions
      return safeVersions[safeVersions.length - 1].version;
    }
  };

  return {
    findSafeVersion,
  };
};

export default new SafeVersionService();
